import React from 'react';
import DemoRequestForm from './pages/components/DemoRequestForm';

const App: React.FC = () => {
  return (
    <div>
      <DemoRequestForm />
    </div>
  );
};

export default App;
